import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=517a0ed7"
import script from "./CreateAccount.ts?vue&type=script&lang=js&external"
export * from "./CreateAccount.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports